import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { SeverityChip } from "./SeverityPicker";

export function SectionAccordion({
    section, defaultOpen = false, findingsByItem, locked,
    renderItem,
}) {
    const [open, setOpen] = useState(defaultOpen);
    const items = section.items || [];
    const sectionSummary = items.reduce(
        (acc, item) => {
            const sev = findingsByItem[item.id]?.severity;
            if (sev === "green") acc.green++;
            else if (sev === "yellow") acc.yellow++;
            else if (sev === "red") acc.red++;
            else if (sev === "na") acc.na++;
            else acc.unset++;
            return acc;
        },
        { green: 0, yellow: 0, red: 0, na: 0, unset: 0 },
    );
    const filledCount = sectionSummary.green + sectionSummary.yellow + sectionSummary.red + sectionSummary.na;

    return (
        <div
            className="overflow-hidden rounded-lg border border-zinc-200 bg-white dark:border-zinc-800 dark:bg-zinc-950"
            data-testid={`section-${section.id}`}
        >
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                data-testid={`section-${section.id}-toggle`}
                className="flex w-full items-center justify-between gap-3 px-3 py-3 text-left transition-colors hover:bg-zinc-50 dark:hover:bg-zinc-900 sm:px-4"
            >
                <div className="flex min-w-0 items-center gap-2">
                    {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                    <div className="min-w-0">
                        <div className="truncate font-semibold">{section.name}</div>
                        <div className="font-mono text-[10px] uppercase tracking-wider text-zinc-500">
                            {filledCount}/{items.length} filled
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-1">
                    {sectionSummary.red > 0 && <SeverityChip severity="red" />}
                    {sectionSummary.yellow > 0 && <SeverityChip severity="yellow" />}
                    {sectionSummary.green > 0 && (
                        <span
                            className="hidden rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-emerald-800 sm:inline-flex dark:bg-emerald-900/30 dark:text-emerald-300"
                        >
                            ✓ {sectionSummary.green}
                        </span>
                    )}
                </div>
            </button>
            {open ? (
                <div
                    className={cn(
                        "grid gap-3 border-t border-zinc-100 p-3 sm:grid-cols-2 sm:p-4 lg:grid-cols-3 dark:border-zinc-800",
                        locked && "opacity-95",
                    )}
                >
                    {items.map((item) => renderItem(item, section))}
                </div>
            ) : null}
        </div>
    );
}
